var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("circle", {
        attrs: {
          cx: "12",
          cy: "12",
          r: "10",
          stroke: _vm.color,
          "stroke-width": "2",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M12 7v5l3 3",
          stroke: _vm.color,
          "stroke-width": "2",
          "stroke-linecap": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }